import { API_BASE } from "../api";

/** Is a username free? Public, no session; fails open (the register call is the last word).
 *  Shared by SignupFlow and the share page's light sign-up sheet (game-on-freeform U17). */
export async function checkUsernamePublic(name: string): Promise<{ available: boolean; reason?: string }> {
  try {
    const resp = await fetch(`${API_BASE}/auth/username/check?candidate=${encodeURIComponent(name)}`);
    if (!resp.ok) return { available: true }; // fail open for UX
    return await resp.json();
  } catch {
    return { available: true };
  }
}
